import { graphql, useStaticQuery } from "gatsby";
import React from "react";

interface SEOProps {
  title?: string;
  description?: string;
  pathname?: string;
  canonicalUrl?: string;
  children?: React.ReactNode;
}

export function SEO({ title, description, pathname, canonicalUrl, children }: SEOProps) {
  const data = useStaticQuery(graphql`
    query {
      site {
        siteMetadata {
          title
          description
          siteUrl
        }
      }
    }
  `);

  const siteUrl = data.site.siteMetadata.siteUrl;
  const seo = {
    title: title || data.site.siteMetadata.title,
    description: description || data.site.siteMetadata.description,
    url: `${siteUrl}${pathname || ``}`,
    canonical: canonicalUrl || `${siteUrl}${pathname || ``}`,
  };

  return (
    <>
      <title>{seo.title}</title>
      <link rel="canonical" href={seo.canonical} />
      <meta name="description" content={seo.description} />
      <meta property="og:title" content={seo.title} />
      <meta property="og:description" content={seo.description} />
      <meta property="og:url" content={seo.url} />
      <meta property="og:type" content="website" />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={seo.title} />
      <meta name="twitter:description" content={seo.description} />
      {children}
    </>
  );
}
